var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-body dashboard"},[_c('div',{staticClass:"page-title-bar"},[_c('h1',[_vm._v("Social Media Marketing")])]),_c('div',{staticClass:"body-flex"},[_vm._v(" Coming Soon ")])])
}]

export { render, staticRenderFns }